const HORSE_STATE = {
  runner: 'RUNNER',
  nonRunner: 'NON_RUNNER',
};

export {
  HORSE_STATE,
};
